export const BuildInfo = {timestamp:1792174165000}
